import { render } from "./PlaceContactPopup.vue?vue&type=template&id=91c9c630&scoped=true"
import script from "./PlaceContactPopup.vue?vue&type=script&lang=js"
export * from "./PlaceContactPopup.vue?vue&type=script&lang=js"

import "./PlaceContactPopup.vue?vue&type=style&index=0&id=91c9c630&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c9c630"]])

export default __exports__